// Whether the page is the docked shell (layouts/application_v2), which stamps
// `data-layout="app"` on <body>; side-menu.css keys its desktop rules on the
// same attribute. The classic layouts/application carries no stamp: there the
// menu stays an overlay on desktop and the assistant keeps its floating card.
// Read at call time, because Turbo swaps <body> on every visit.
export const inAppShell = (): boolean => document.body.dataset.layout === "app"
